<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/caselist' }">管理后台</el-breadcrumb-item>
      <el-breadcrumb-item>案件列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <!-- 搜索与操作栏 -->
      <div class="search-section">
        <!-- 基本搜索条件 -->
        <el-row :gutter="15" type="flex" justify="start" align="middle">
          <el-col :span="5">
            <el-input 
              placeholder="请输入姓名" 
              v-model="queryInfo.name" 
              clearable 
              @clear="getCasesList"
              size="small"
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-input 
              placeholder="请输入案件号" 
              v-model="queryInfo.contract_no" 
              clearable 
              @clear="getCasesList"
              size="small"
            ></el-input>
          </el-col>
          <el-col :span="2">
            <el-button 
              type="text" 
              @click="toggleSearchExpanded" 
              size="small" 
              style="padding: 0; color: #409EFF;"
            >
              <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              {{ searchExpanded ? '收起' : '展开' }}
            </el-button>
          </el-col>
          <el-col :span="12">
            <div style="text-align: left;">
              <el-button type="primary" @click="getCasesList" icon="el-icon-search" size="small">搜索</el-button>
              <el-button type="warning" @click="clearSearch" icon="el-icon-refresh" size="small">清空</el-button>
            </div>
          </el-col>
        </el-row>
        
        <!-- 高级搜索条件 -->
        <div v-show="searchExpanded" class="advanced-search">
          <el-row :gutter="15" type="flex" justify="start" align="middle" style="margin-top: 8px;">
            <el-col :span="5">
              <el-input 
                placeholder="请输入身份证号" 
                v-model="queryInfo.id_card" 
                clearable 
                @clear="getCasesList"
                size="small"
              ></el-input>
            </el-col>
            <el-col :span="4">
              <el-input 
                placeholder="请输入手机号" 
                v-model="queryInfo.phone" 
                clearable 
                @clear="getCasesList"
                size="small"
              ></el-input>
            </el-col>
            <el-col :span="6">
              <el-select 
                placeholder="请选择数据来源" 
                v-model="selectedDataSources"
                clearable 
                @change="getCasesList" 
                size="small"
                style="width: 100%"
              >
                <el-option label="API" value="API"></el-option>
                <el-option label="文件导入" value="文件导入"></el-option>
                <el-option label="手动创建" value="手动创建"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-date-picker
                v-model="dateRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期时间"
                end-placeholder="结束日期时间"
                @change="getCasesList"
                size="small"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 操作按钮区域 -->
      <div class="operation-section">
        <el-row :gutter="15" style="margin-top: 5px;">
          <el-col :span="24">
            <div class="operation-layout">
              <!-- 左侧操作按钮 -->
              <div class="operation-buttons">
                <el-button type="primary" @click="showAddDialog" icon="el-icon-plus" size="small">添加案件</el-button>
                
                <el-upload action="https" :http-request="uploadExcelFile" style="display: inline-block;">
                  <el-button size="small" type="success" icon="el-icon-upload2">批量上传案件</el-button>
                </el-upload>
                
                <el-button size="small" type="info" @click="downLoadTemplate" icon="el-icon-download">案件模板下载</el-button>
                
                <el-button type="danger" @click="bulkDelete" :disabled="selectedIds.length === 0" icon="el-icon-delete" size="small">批量删除</el-button>
                
                <el-upload
                  action="https"
                  :http-request="uploadDeleteExcelFile"
                  :show-file-list="false"
                  style="display: inline-block;"
                >
                  <el-button size="small" type="warning" plain icon="el-icon-delete">上传文件删除</el-button>
                </el-upload>
                
                <el-button type="danger" @click="deleteAll" plain icon="el-icon-delete-solid" size="small">全部删除</el-button>
              </div>
              
              <!-- 中间分页控制 -->
              <div class="page-controls">
                <el-button 
                  @click="prevPage" 
                  :disabled="queryInfo.pagenum <= 1" 
                  icon="el-icon-arrow-left" 
                  size="small"
                >上一页</el-button>
                <el-button 
                  @click="nextPage" 
                  :disabled="queryInfo.pagenum >= Math.ceil(total / queryInfo.pagesize)" 
                  icon="el-icon-arrow-right" 
                  size="small"
                >下一页</el-button>
              </div>
              
              <!-- 右侧表格列控制 -->
              <div class="table-control">
                <el-select
                  v-model="selectedColumns"
                  multiple
                  collapse-tags
                  placeholder="选择显示列"
                  size="small"
                  style="width: 180px;"
                >
                  <el-option label="姓名" value="name"></el-option>
                  <el-option label="身份证号码" value="id_card"></el-option>
                  <el-option label="手机号码" value="phone"></el-option>
                  <el-option label="借款时间" value="borrow_date"></el-option>
                  <el-option label="逾期金额" value="overdue_amount"></el-option>
                  <el-option label="借贷平台名称" value="borrow_platform_name"></el-option>
                  <el-option label="案件号" value="contract_no"></el-option>
                  <el-option label="调解号" value="case_number"></el-option>
                  <el-option label="协商号" value="mediate_no"></el-option>
                  <el-option label="导入时间" value="add_time"></el-option>
                  <el-option label="更新时间" value="last_pushed_at"></el-option>
                  <el-option label="案件来源" value="case_from"></el-option>
                </el-select>
                <span style="margin-left: 6px; color: #666; font-size: 12px;">控制表格列</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 案件列表 -->
      <el-table border stripe :data="cases" @selection-change="handleSelectionChange">
        <!-- 复选框列 -->
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column label="姓名" prop="name" v-if="selectedColumns.includes('name')"></el-table-column>
        <el-table-column label="身份证号码" prop="id_card" width="180" v-if="selectedColumns.includes('id_card')"></el-table-column>
        <el-table-column label="手机号码" prop="phone" width="120" v-if="selectedColumns.includes('phone')"></el-table-column>
        <el-table-column prop="borrow_date" label="借款时间" v-if="selectedColumns.includes('borrow_date')"></el-table-column>
        <el-table-column label="逾期金额" prop="overdue_amount" v-if="selectedColumns.includes('overdue_amount')"></el-table-column>
        <el-table-column label="借贷平台名称" prop="borrow_platform_name" v-if="selectedColumns.includes('borrow_platform_name')"></el-table-column>
        <el-table-column label="案件号" prop="contract_no" v-if="selectedColumns.includes('contract_no')"></el-table-column>
        <el-table-column prop="case_number" label="调解号" v-if="selectedColumns.includes('case_number')"></el-table-column>
        <el-table-column prop="mediate_no" label="协商号" v-if="selectedColumns.includes('mediate_no')"></el-table-column>
        <el-table-column prop="add_time" label="导入时间" :formatter="formatDate" v-if="selectedColumns.includes('add_time')"></el-table-column>
        <el-table-column prop="last_pushed_at" label="更新时间" :formatter="formatDate" v-if="selectedColumns.includes('last_pushed_at')"></el-table-column>
        <el-table-column prop="case_from" label="案件来源" v-if="selectedColumns.includes('case_from')"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页控制 -->
      <div class="pagination-section">
        <el-pagination 
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum" 
          :page-sizes="[10, 20, 50, 100]" 
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper" 
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加or编辑弹出层 -->
    <el-dialog
      :visible.sync="dialogVisble"
      width="50%"
      @close="addOrEditDialogClosed"
    >
      <el-form
        ref="addOrEditFormRef"
        :model="addOrEditForm"
        :rules="addOrEditFormRules"
        label-width="180px"
      >
        <el-form-item label="姓名">
          <el-input v-model="addOrEditForm.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码">
          <el-input v-model="addOrEditForm.id_card"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="addOrEditForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="借贷平台名称">
          <el-input v-model="addOrEditForm.borrow_platform_name"></el-input>
        </el-form-item>
        <el-form-item label="借款平台收款账户户名">
          <el-input v-model="addOrEditForm.borrow_platform_get_name"></el-input>
        </el-form-item>
        <el-form-item label="借款平台收款账号开户银行">
          <el-input v-model="addOrEditForm.borrow_platform_get_bank"></el-input>
        </el-form-item>
        <el-form-item label="借款平台收款银行账号">
          <el-input
            v-model="addOrEditForm.borrow_platform_get_account"
          ></el-input>
        </el-form-item>
        <el-form-item label="借款日期">
          <el-input v-model="addOrEditForm.borrow_date"></el-input>
        </el-form-item>
        <el-form-item label="借款总金额">
          <el-input v-model="addOrEditForm.borrow_total"></el-input>
        </el-form-item>
        <el-form-item label="案件号">
          <el-input v-model="addOrEditForm.contract_no"></el-input>
        </el-form-item>
        <el-form-item label="逾期金额">
          <el-input v-model="addOrEditForm.overdue_amount"></el-input>
        </el-form-item>
        <el-form-item label="录入日期">
          <el-input v-model="addOrEditForm.add_date"></el-input>
        </el-form-item>
        <el-form-item label="调解号">
          <el-input v-model="addOrEditForm.mediate_no"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisble = false">取 消</el-button>
        <el-button type="primary" @click="addOrEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CaseList",
  data() {
    return {
      dialogVisble: false,
      selectedDataSources: [],
      addOrEditForm: {
        id: -1,
        name: "",
        id_card: "",
        phone: "",
        borrow_platform_name: "",
        borrow_platform_get_name: "",
        borrow_platform_get_bank: "",
        borrow_platform_get_account: "",
        borrow_date: "",
        borrow_total: "",
        contract_no: "",
        overdue_amount: "",
        add_date: "",
        mediate_no: "",
      },
      isEdit: false,
      addOrEditFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        id_card: [{ required: true, message: "请输入身份证号码", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话号码", trigger: "blur" }],
      },
      cases: [],
      queryInfo: {
        name: "",
        id_card: "",
        contract_no: "",
        phone: "",
        data_source: "",
        start_date: "",
        end_date: "",
        pagenum: 1,
        pagesize: 10,
      },
      dateRange: [],
      total: 0,
      // +++ START: 新增数据 +++
      // 存储选中的ID列表
      selectedIds: [],
      selectedColumns: ['name', 'id_card', 'phone', 'borrow_date', 'overdue_amount', 'borrow_platform_name', 'contract_no', 'case_number', 'mediate_no', 'add_time', 'last_pushed_at', 'case_from'],
      // 搜索条件展开状态
      searchExpanded: false,
      // +++ END: 新增数据 +++
    };
  },
  created() {
    this.getCasesList();
  },
  methods: {
    clearSearch() {
      this.queryInfo.name = '';
      this.queryInfo.id_card = '';
      this.queryInfo.contract_no = '';
      this.queryInfo.phone = '';
      this.selectedDataSources = [];
      this.dateRange = '';
      this.getCasesList();
    },
    // 添加按钮弹出层
    showAddDialog() {
      this.dialogVisble = true;
    },
    // 关闭弹出层
    addOrEditDialogClosed() {
      this.$refs.addOrEditFormRef.resetFields();
      this.addOrEditForm.name = "";
      this.addOrEditForm.id_card = "";
      this.addOrEditForm.phone = "";
      this.addOrEditForm.borrow_platform_name = "";
      this.addOrEditForm.borrow_platform_get_name = "";
      this.addOrEditForm.borrow_platform_get_bank = "";
      this.addOrEditForm.borrow_platform_get_account = "";
      this.addOrEditForm.borrow_date = "";
      this.addOrEditForm.borrow_total = "";
      this.addOrEditForm.contract_no = "";
      this.addOrEditForm.overdue_amount = "";
      this.addOrEditForm.add_date = "";
      this.addOrEditForm.mediate_no = "";
    },
    // 弹层添加和修改按钮事件
    addOrEdit() {
      if (!this.isEdit) {
        this.addCase();
      } else {
        this.editCase();
      }
    },
    // 添加
    addCase() {
      this.$refs.addOrEditFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.post("cases", {
          name: this.addOrEditForm.name,
          id_card: this.addOrEditForm.id_card,
          phone: this.addOrEditForm.phone,
          borrow_platform_name: this.addOrEditForm.borrow_platform_name,
          borrow_platform_get_name: this.addOrEditForm.borrow_platform_get_name,
          borrow_platform_get_bank: this.addOrEditForm.borrow_platform_get_bank,
          borrow_platform_get_account:
            this.addOrEditForm.borrow_platform_get_account,
          borrow_date: this.addOrEditForm.borrow_date,
          borrow_total: this.addOrEditForm.borrow_total,
          contract_no: this.addOrEditForm.contract_no,
          overdue_amount: this.addOrEditForm.overdue_amount,
          add_date: this.addOrEditForm.add_date,
          mediate_no: this.addOrEditForm.mediate_no,
        });
        if (res.meta.status !== 201) {
          return this.$message.error("添加失败！");
        }
        this.$message.success("添加成功！");
        this.getCasesList();
        this.dialogVisble = false;
      });
    },
    // 修改
    editCase() {
      this.$refs.addOrEditFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.put(
          `cases/${this.addOrEditForm.id}`,
          {
            name: this.addOrEditForm.name,
            id_card: this.addOrEditForm.id_card,
            phone: this.addOrEditForm.phone,
            borrow_platform_name: this.addOrEditForm.borrow_platform_name,
            borrow_platform_get_name:
              this.addOrEditForm.borrow_platform_get_name,
            borrow_platform_get_bank:
              this.addOrEditForm.borrow_platform_get_bank,
            borrow_platform_get_account:
              this.addOrEditForm.borrow_platform_get_account,
            borrow_date: this.addOrEditForm.borrow_date,
            borrow_total: this.addOrEditForm.borrow_total,
            contract_no: this.addOrEditForm.contract_no,
            overdue_amount: this.addOrEditForm.overdue_amount,
            add_date: this.addOrEditForm.add_date,
            mediate_no: this.addOrEditForm.mediate_no,
          }
        );
        if (res.meta.status !== 200) {
          return this.$message.error("修改失败！");
        }
        this.$message.success("修改成功！");
        this.getCasesList();
        this.dialogVisble = false;
      });
    },
    formatDate(row, column, cellValue) {
      if (cellValue) {
        const date = new Date(cellValue * 1000);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      }
      return '';
    },
    // 根据分页获取对应的案件列表
    async getCasesList() {
      this.queryInfo.data_source =this.selectedDataSources //this.selectedDataSources.join(','); //改成单选
      if(this.dateRange){ //修复bug：清空日期的清空下需要先判断
         this.queryInfo.start_date = this.dateRange[0] ? Math.floor(new Date(this.dateRange[0]).getTime() / 1000) : '';
         this.queryInfo.end_date = this.dateRange[1] ? Math.floor(new Date(this.dateRange[1]).getTime() / 1000) : '';
      }
    //   console.log(this.queryInfo)
     
      const { data: res } = await this.$http.get("cases", {
        params: this.queryInfo,
      });

      if (res.meta.status !== 200) {
        return this.$message.error("获取案件列表失败！");
      }
      this.$message.success("获取案件列表成功！");
      console.log(res.data);
      this.cases = res.data.cases;
      this.total = res.data.total;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getCasesList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getCasesList();
    },
    // 删除案件
    async removeById(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该案件, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }
      const { data: res } = await this.$http.delete(`cases/${id}`);
      if (res.meta.status !== 200) {
        console.log(res.meta.msg);
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getCasesList();
    },
    showEditDialog(row) {
      this.dialogVisble = true;
      this.isEdit = true;
      this.addOrEditForm.id = row.id;
      this.addOrEditForm.name = row.name;
      this.addOrEditForm.id_card = row.id_card;
      this.addOrEditForm.phone = row.phone;
      this.addOrEditForm.borrow_platform_name = row.borrow_platform_name;
      this.addOrEditForm.borrow_platform_get_name =
        row.borrow_platform_get_name;
      this.addOrEditForm.borrow_platform_get_bank =
        row.borrow_platform_get_bank;
      this.addOrEditForm.borrow_platform_get_account =
        row.borrow_platform_get_account;
      this.addOrEditForm.borrow_date = row.borrow_date;
      this.addOrEditForm.borrow_total = row.borrow_total;
      this.addOrEditForm.contract_no = row.contract_no;
      this.addOrEditForm.overdue_amount = row.overdue_amount;
      this.addOrEditForm.add_date = row.add_date;
      this.addOrEditForm.mediate_no = row.mediate_no;
    },
    // 批量导入
    async uploadExcelFile(file) {
      let formdata = new FormData();
      console.log(file);
      formdata.append("file", file.file);
      const { data: res } = await this.$http.post("/cases/upload", formdata, {
        "Content-type": "multipart/form-data",
      });
      console.log(res);

      this.$message.success("导入成功！");
      this.getCasesList();
    },
    // 模板下载
    downLoadTemplate() {
      let a = document.createElement("a"); // 创建a标签
      a.href = "static/case.xlsx"; // 文件路径
      a.download = "case.xlsx"; // 文件名称
      a.style.display = "none"; // 隐藏a标签
      document.body.appendChild(a);
      // 定时器(可选)
      setTimeout(() => {
        a.click(); // 模拟点击(要加)
        document.removeChild(a); //删除元素(要加)
        setTimeout(() => {
          self.URL.revokeObjectURL(a.href); // 用来释放文件路径(可选)
        }, 200);
      }, 66);
    },

     // +++ START: 新增方法 +++
    /**
     * @description 监听表格复选框状态变化
     * @param {Array} selection 当前选中的行数据数组
     */
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id);
    },

    /**
     * @description 批量删除
     */
    async bulkDelete() {
      // 弹出确认框
      const confirmResult = await this.$confirm(
        `此操作将永久删除选中的 ${this.selectedIds.length} 个案件, 是否继续?`,
        "警告",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err); // 捕获用户点击取消的操作

      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除");
      }

      // 调用批量删除接口
      const { data: res } = await this.$http.post('cases/bulk-delete', { ids: this.selectedIds });

      if (res.meta.status !== 200) {
        return this.$message.error("批量删除失败！");
      }
      this.$message.success("批量删除成功！");
      this.getCasesList(); // 刷新列表
    },

    /**
     * @description 全部删除
     */
    async deleteAll() {
        // 在这里定义你的确认密码
        const CONFIRM_PASSWORD = "fadingfading"; // 强烈建议将此密码存储在更安全的地方，例如Vuex或环境变量中

        // 步骤 1: 弹出密码输入框
        const promptResult = await this.$prompt(
            '这是一个极其危险的操作！请输入【最高权限删除密码】来继续。', 
            '最高警告：请输入密码', 
            {
                confirmButtonText: '验证密码',
                cancelButtonText: '取消',
                inputType: 'password', // 将输入框类型设为密码
                closeOnClickModal: false, // 防止点击遮罩层关闭
                inputValidator: (val) => { // 添加一个简单的验证器
                    if (val === null || val.trim() === '') {
                        return '密码不能为空';
                    }
                    return true;
                }
            }
        ).catch(err => err); // 捕获用户点击取消的操作

        // 如果用户点击了取消按钮
        if (promptResult.action !== 'confirm') {
            return this.$message.info('已取消全部删除操作');
        }

        // 步骤 2: 验证密码
        const userInputPassword = promptResult.value;
        if (userInputPassword !== CONFIRM_PASSWORD) {
            // 密码不正确，提示错误并终止
            return this.$message.error('密码错误！操作已终止。');
        }

        // 步骤 3: 密码正确后，进行二次最终确认
        const finalConfirmResult = await this.$confirm(
            '密码验证通过。您确定要删除所有案件吗？此操作无法撤销！',
            '最终确认',
            {
                confirmButtonText: '我确定，执行删除',
                cancelButtonText: '不，我再想想',
                type: 'error',
            }
        ).catch(err => err);

        if (finalConfirmResult !== 'confirm') {
            return this.$message.info('已在最终确认阶段取消操作。');
        }
        // 步骤 4: 执行删除
        this.$message.success('验证通过，正在执行删除...');
        const { data: res } = await this.$http.post('cases/delete-all');

        if (res.meta.status !== 200) {
            return this.$message.error("全部删除失败！");
        }
        this.$message.success("所有案件已成功删除！");
        this.getCasesList(); // 刷新列表
    },
    // +++ END: 新增方法 +++

    // +++ START: 新增方法 +++
    async uploadDeleteExcelFile(file) {
      const confirmResult = await this.$confirm(
        `此操作将使用文件 "${file.file.name}" 中的案件合同号进行批量软删除，请确认文件内容和格式正确。是否继续?`,
        "警告",
        {
          confirmButtonText: "确定，执行删除",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已取消上传删除操作");
      }

      let formdata = new FormData();
      formdata.append("file", file.file);
      
      const loading = this.$loading({
        lock: true,
        text: '正在上传和处理文件，此过程可能需要一些时间，请勿关闭页面...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      });

      try {
        const { data: res } = await this.$http.post("/cases/upload-delete", formdata, {
          "Content-type": "multipart/form-data",
        });

        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg || "批量删除操作失败！");
        } else {
          this.$alert(res.data.message, '操作完成', {
            confirmButtonText: '确定',
            callback: () => {
              this.$message.success('列表已刷新');
            }
          });
          this.getCasesList();
        }
      } catch (error) {
        this.$message.error("请求失败，无法连接到服务器或服务器发生错误。");
      } finally {
        loading.close();
      }
    },
    // +++ END: 新增方法 +++

    // 切换搜索条件展开状态
    toggleSearchExpanded() {
      this.searchExpanded = !this.searchExpanded;
    },

    // 上一页
    prevPage() {
      if (this.queryInfo.pagenum > 1) {
        this.queryInfo.pagenum--;
        this.getCasesList();
      }
    },

    // 下一页
    nextPage() {
      const totalPages = Math.ceil(this.total / this.queryInfo.pagesize);
      if (this.queryInfo.pagenum < totalPages) {
        this.queryInfo.pagenum++;
        this.getCasesList();
      }
    },
  },
};
</script>
<style scoped>
.el-row {
  margin-bottom: 8px;
}

/* 搜索区域样式 */
.search-section {
  background: #f8f9fa;
  padding: 8px 8px;
  border-radius: 4px;
  margin-bottom: 2px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.advanced-search {
  border-top: 1px solid #e0e0e0;
  padding-top: 6px;
  margin-top: 6px;
}

/* 操作按钮区域样式 */
.operation-section {
  background: #ffffff;
  padding: 6px 12px;
  border-radius: 4px;
  margin-bottom: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.operation-layout {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  min-height: 28px;
}

.operation-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.operation-buttons .el-button {
  margin: 0;
  height: 28px;
  line-height: 1;
}

.operation-buttons .el-upload {
  margin: 0;
}

.operation-buttons .el-upload .el-button {
  height: 28px;
  line-height: 1;
}

/* 中间分页控制区域 */
.page-controls {
  display: flex;
  gap: 6px;
  margin: 0 20px;
}

.page-controls .el-button {
  margin: 0;
  height: 28px;
  line-height: 1;
}

/* 表格控制区域 */
.table-control {
  display: flex;
  align-items: center;
  padding: 3px 8px;
  background: #f5f5f5;
  border-radius: 4px;
}

/* 分页控制区域 */
.pagination-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .operation-layout {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  
  .operation-buttons {
    flex-direction: column;
    align-items: stretch;
  }
  
  .operation-buttons .el-button,
  .operation-buttons .el-upload {
    width: 100%;
  }
  
  .page-controls {
    margin: 0;
    justify-content: center;
  }
  
  .table-control {
    flex-direction: column;
    align-items: stretch;
  }
  
  .table-control .el-select {
    width: 100% !important;
    margin-bottom: 8px;
  }
}

/* 美化表格样式 */
.el-table {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
}

.el-table th {
  background: #f8f9fa;
  color: #495057;
  font-weight: 600;
  padding: 6px 0;
}

.el-table td {
  padding: 8px 0;
}

/* 分页样式 */
.el-pagination {
  text-align: center;
}

/* 紧凑布局 */
.el-card {
  margin-bottom: 0;
}

.el-card .el-card__body {
  padding: 12px;
}
</style>